<template>
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.3863 7.24414L7.24414 21.3863" stroke="#242653"/>
        <path d="M21.5699 21.5635L7.07418 7.06779" stroke="#242653"/>
    </svg>
</template>